import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import EChart from "../../../Dashboard/Graphic/charts/EChart";
import { dropZeroPoints, pivotToChartData } from "../utils/pivotToChartData";

/**
 * Renders the pivot as one of the dashboard's chart types, reusing the shared
 * EChart (Apache ECharts) so the Builder and static dashboard look alike.
 *
 * EChart plots a single series of [{label, count}], so `seriesKey`
 * decides which slice of the cross is charted (see pivotToChartData).
 * `hideZeros` drops zero points, as dashboard pieces do; off in the Builder so
 * its chart keeps every row of the table.
 */
export const PivotChart = ({ pivot, type, seriesKey, title, valueMode, hideZeros = false }) => {
  const [t] = useTranslation("exports");

  const data = useMemo(() => {
    const points = pivotToChartData(pivot, seriesKey, valueMode);
    return hideZeros ? dropZeroPoints(points) : points;
  }, [pivot, seriesKey, valueMode, hideZeros]);

  const chartData = useMemo(
    // `type: "pivot"` is inert for EChart (it only branches on the chart `type` prop).
    () => ({ id: "builder-pivot", title, type: "pivot", data }),
    [title, data]
  );

  if (!data.length) {
    return (
      <Box className="builder-panel builder-panel--hint dyTheme1 dyBorder1 rounded">
        <Typography className="builder-empty">
          {t("builder.no_chart_data")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className="builder-panel dyTheme1 dyBorder1 rounded">
      <EChart
        chartData={chartData}
        title={title}
        type={type}
        opacity={0.8}
      />
    </Box>
  );
};
